var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
          on: {
            select: function($event) {
              return _vm.handover($event)
            }
          }
        },
        [
          _c("el-menu-item", { attrs: { index: "anchorMarketList" } }, [
            _vm._v(_vm._s(_vm.$t("anchorMarketOperationRecord")))
          ]),
          _c(
            "el-menu-item",
            { attrs: { index: "restrictionAnchorMarketList" } },
            [_vm._v(_vm._s(_vm.$t("restrictedPlayerIdList")))]
          )
        ],
        1
      ),
      _c("anchorMarketList", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "anchorMarketList",
            expression: "activeIndex == 'anchorMarketList'"
          }
        ],
        ref: "anchorMarketList"
      }),
      _c("restrictionAnchorMarketList", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "restrictionAnchorMarketList",
            expression: "activeIndex == 'restrictionAnchorMarketList'"
          }
        ],
        ref: "restrictionAnchorMarketList"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }